import { render } from "./ThankYou.vue?vue&type=template&id=9c7255f0"
const script = {}

import exportComponent from "/vercel/path0/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__